App = App || {};

App.RegisterSales = (function ($, Vue) {
	"use strict";

	function init(rootElement) {
		rootElement = rootElement || document.getElementById("register-sales-app");
		if (!rootElement || rootElement.dataset.mounted)
			return;

		rootElement.dataset.mounted = "1";

		new Vue({
			el: rootElement,
			data: {
				memberId: String(rootElement.getAttribute("data-member-id") || ""),
				member: {},
				items: [],
				appLoading: true,
				form: {
					item: null,
					serialNumber: "",
					comment: "",
					dateOfSale: "",
					bpCodeOverride: false
				},
				lineItems: [],
				tableFields: [
					{ key: "sonaItemNo", label: "Model #", sortable: false },
					{ key: "description", label: "Description", sortable: false },
					{ key: "serialNumber", label: "Serial #", sortable: false },
					{ key: "dateOfSale", label: "Date of Sale", sortable: false },
					{ key: "points", label: "Points", sortable: false },
					{ key: "comment", label: "Comment", sortable: false },
					{ key: "actions", label: "", sortable: false }
				],
				isSubmitting: false,
				alertMessage: "",
				alertErrors: [],
				isComplete: false,
				serialState: "idle",
				serialError: "",
				serialCheckTimer: null,
				activeSerialRequest: null
			},
			computed: {
				totalPoints: function () {
					return this.lineItems.reduce(function (sum, row) {
						var n = Number(row.points);
						return sum + (isNaN(n) ? 0 : n);
					}, 0);
				},
				itemsByItemNo: function () {
					return (this.items || []).slice().sort((a, b) =>
						String(a.sonaItemNo || "").localeCompare(String(b.sonaItemNo || ""), undefined, { sensitivity: "base" })
					);
				},
				itemsByDescription: function () {
					return (this.items || []).slice().sort((a, b) =>
						String(a.description || "").localeCompare(String(b.description || ""), undefined, { sensitivity: "base" })
					);
				}
			},
			watch: {
				"form.item": function () {
					this.scheduleSerialValidation();
				},
				"form.bpCodeOverride": function () {
					this.scheduleSerialValidation();
				}
			},
			methods: {
				normalizeSerial: function (s) {
					return (s || "").trim().toUpperCase();
				},

				todayIso: function () {
					var d = new Date();
					var mm = String(d.getMonth() + 1).padStart(2, "0");
					var dd = String(d.getDate()).padStart(2, "0");
					return d.getFullYear() + "-" + mm + "-" + dd;
				},

				localDateStringToUtcIso: function (yyyyMmDd) {
					if (!yyyyMmDd || !/^\d{4}-\d{2}-\d{2}$/.test(yyyyMmDd)) return null;
					var parts = yyyyMmDd.split("-");
					var d = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
					return isNaN(d) ? null : d.toISOString();
				},

				toUtcStartOfDayIso: function (localYmd) {
					if (!localYmd) return null;
					var parts = String(localYmd).split("-");
					if (parts.length !== 3) return null;
					var y = parseInt(parts[0], 10), m = parseInt(parts[1], 10) - 1, d = parseInt(parts[2], 10);
					var localMidnight = new Date(y, m, d, 0, 0, 0, 0);
					return new Date(Date.UTC(localMidnight.getFullYear(), localMidnight.getMonth(), localMidnight.getDate(), 0, 0, 0, 0)).toISOString();
				},

				formatDate: function (value) {
					if (!value)
						return "";

					if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
						var p = value.split("-");
						return p[1] + "/" + p[2] + "/" + p[0];
					}
					var normalized = String(value).replace(/(\.\d{3})\d+$/, "$1");
					var date = value instanceof Date ? value : new Date(normalized);
					if (isNaN(date)) return String(value);
					return date.toLocaleDateString("en-US", {
						year: "numeric",
						month: "2-digit",
						day: "2-digit"
					});
				},

				submitAll: function () {
					if (!this.lineItems.length || this.isSubmitting) return;

					this.isSubmitting = true;
					this.alertMessage = "";
					this.alertErrors = [];

					var payload = {
						memberId: this.memberId,
						items: this.lineItems.map(function (li) {
							return {
								itemId: li.itemId,
								serialNumber: li.serialNumber,
								dateOfSale: li.dateOfSale || null,
								comment: li.comment || ""
							};
						}, this)
					};

					$.ajax({
						url: "/api/earn/submit",
						method: "POST",
						contentType: "application/json",
						dataType: "json",
						headers: { "Accept": "application/json" },
						timeout: 30000,
						data: JSON.stringify(payload)
					}).done((response) => {
						if (response && response.success === true) {
							this.isComplete = true;
							this.lineItems = [];
							this.resetFormForNext();
						}
						else {
							this.alertMessage = (response && response.message) || "Submission failed.";
							this.alertErrors = ((response && response.data && response.data.errors) || [])
								.map(function (e) {
									return e.description || e;
								})
								.filter(Boolean);
						}
					}).fail((jq, status, err) => {
						this.alertMessage = "Submission failed.";
						console.error("Register sales submit error:", status, err);
					}).always(() => {
						this.isSubmitting = false;
						this.$nextTick(() => {
							if (this.$refs.topAlert && this.$refs.topAlert.focus) this.$refs.topAlert.focus({ preventScroll: true });
						});
					});
				},

				addLineItem: function () {
					if (!this.form.item || this.serialState !== "valid" || !this.form.dateOfSale)
						return;

					const priceClass = this.member?.priceClass || "Standard";

					this.lineItems.push({
						itemId: this.form.item.id,
						sonaItemNo: this.form.item.sonaItemNo,
						description: this.form.item.description,
						serialNumber: this.form.serialNumber,
						dateOfSale: this.form.dateOfSale,
						points: this.form.item.prices.find(p => p.aspect === "Earned" && p.class === priceClass)?.value ?? 0,
						comment: this.form.comment || ""
					});

					this.isComplete = false;
					this.alertMessage = "";
					this.alertErrors = [];

					this.resetFormForNext();
				},

				removeLineItem: function (rowIndex) {
					if (rowIndex < 0 || rowIndex >= this.lineItems.length) return;
					this.lineItems.splice(rowIndex, 1);
				},

				resetFormForNext: function () {
					this.form.serialNumber = "";
					this.form.comment = "";
					this.form.dateOfSale = this.todayIso();
					this.serialState = "idle";
					this.serialError = "";
					if (this.$refs.serialInput)
						this.$refs.serialInput.focus();
				},

				onSerialInput: function () {
					this.scheduleSerialValidation();
				},

				scheduleSerialValidation: function () {
					if (this.serialCheckTimer) {
						clearTimeout(this.serialCheckTimer);
						this.serialCheckTimer = null;
					}
					if (this.activeSerialRequest && this.activeSerialRequest.abort) {
						try { this.activeSerialRequest.abort(); } catch (_) { }
						this.activeSerialRequest = null;
					}
					var value = this.form.serialNumber || "";
					if (value.length < 3) {
						this.serialState = "idle";
						this.serialError = "";
						this.updateSerialFieldValidity();
						return;
					}
					this.serialState = "checking";
					this.serialError = "";
					this.updateSerialFieldValidity();
					this.serialCheckTimer = setTimeout(this.validateSerialAsync, 300);
				},

				validateSerialAsync: function () {
					this.serialCheckTimer = null;
					var entered = this.normalizeSerial(this.form.serialNumber);
					var duplicate = this.lineItems.some(li => this.normalizeSerial(li.serialNumber) === entered && li.itemId === this.form.item.id);

					if (duplicate) {
						this.serialState = "invalid";
						this.serialError = "Serial number has already been added to your list.";
						this.updateSerialFieldValidity();
						return;
					}

					var payload = {
						MemberId: this.memberId || "",
						SerialNumber: this.form.serialNumber || "",
						ItemId: this.form.item ? (this.form.item.id || 0) : 0,
						BpCodeOverride: this.form.bpCodeOverride || false
					};

					this.serialState = "checking";
					this.serialError = "";
					this.updateSerialFieldValidity();

					this.activeSerialRequest = $.ajax({
						url: "/api/serials/validate",
						method: "POST",
						contentType: "application/json",
						dataType: "json",
						headers: { "Accept": "application/json" },
						timeout: 15000,
						data: JSON.stringify(payload)
					}).done((response) => {
						if (response && response.success === true) {
							this.serialState = "valid";
							this.serialError = "";
						} else {
							this.serialState = "invalid";
							this.serialError = (response && response.message) || "Serial not valid.";
						}
					}).fail((jqXHR, status) => {
						if (status === "abort") return;
						this.serialState = "invalid";
						this.serialError = (jqXHR && jqXHR.status === 404)
							? "Validation endpoint not found."
							: "Validation failed.";
					}).always(() => {
						this.activeSerialRequest = null;
						this.updateSerialFieldValidity();
					});
				},

				updateSerialFieldValidity: function () {
					var input = this.$refs.serialInput;
					if (!input || !input.setCustomValidity) return;
					if (this.serialState === "invalid") {
						input.setCustomValidity(this.serialError || "Invalid");
					} else {
						input.setCustomValidity("");
					}
				},

				loadItems: function () {
					return $.ajax({
						url: `/api/earn/items/${this.memberId}`,
						method: "GET",
						dataType: "json"
					}).done(response => {
						if (response && response.success) {
							this.items = response.data;
						}
					}).fail((jqXHR, status, err) => {
						console.error("AJAX error loading items:", status, err);
					});
				},


				loadMember: function () {
					return $.ajax({
						url: `/api/members/${this.memberId}`,
						method: "GET",
						dataType: "json"
					}).done(response => {
						if (response && response.success) {
							this.member = response.data;
						}
					}).fail((jqXHR, status, err) => {
						console.error("AJAX error loading items:", status, err);
					});
				}
			},
			mounted: function () {
				if (!this.form.dateOfSale)
					this.form.dateOfSale = this.todayIso();

				this.$nextTick(() => {
					if (this.$refs.table && this.$refs.table.refresh) this.$refs.table.refresh();
				});

				this.appLoading = true;

				$.when(this.loadItems(), this.loadMember())
					.always(() => {
						this.appLoading = false;
						this.$nextTick(() => {
							if (this.$refs.topAlert && this.$refs.topAlert.focus) this.$refs.topAlert.focus({ preventScroll: true });
						});
					});
			}
		});
	}

	return { init: init };
})(jQuery, Vue);

App.RegisterSales.init();
